export default __webpack_public_path__ + "static/media/LubricantsImg.f25803b8.jpg";